import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css";
import ContactImg from "../assets/photos/contact-page.png";

const Contact = () => {

    const form = useRef();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);

        emailjs
            .sendForm(
                "service_pxjh1db",
                "template_xatre1n",
                form.current,
                "1br-Km8i8QbYWpaPO"
            )
            .then(() => {
                setSubmitted(true);
                form.current.reset();
                setLoading(false);
            })
            .catch((error) => {
                console.log("Status:", error.status);
                console.log("Text:", error.text);
                alert("Error: " + error.text);
                setLoading(false);
            });
    };

    return (
        <main className="contact-container">

            {/* HERO SECTION */}
            <section className="contact-hero">
                <h1>Contact Us</h1>
                <p>We are here to help you</p>
            </section>

            {/* MAP */}
            <section className="map-section">
                <iframe
                    title="Bank Location"
                    src="https://www.google.com/maps?q=446,+Jagannath+Shankar+Seth+Rd+Charni+Road+East,+Kamathi+Wada,+Chira+Bazaar,+Marine+Lines+Mumbai,+Maharashtra+400002+India&output=embed"
                    loading="lazy"
                ></iframe>
            </section>

            {/* SECTION TITLE */}
            <section className="contact-heading">
                <h2>We'd Love to Hear From You</h2>
                <p>Whether it's feedback or a complaint, our team is ready to assist you.</p>
            </section>

            {/* FORM + INFO */}
            <section className="contact-main-section">

                {/* LEFT SIDE - FORM */}
                <div className="contact-form-section">

                    <div className="contact-split-card">

                        {/* LEFT PANEL - FORM */}
                        <div className="contact-form-left">

                            <div className="contact-form-badge">
                                <span className="contact-badge-dot"></span>
                                Feedback &amp; Complaints
                            </div>

                            <h2 className="contact-form-title">Get In Touch</h2>
                            <p className="contact-form-sub">Fill in the details and we'll get back to you shortly.</p>

                            {!submitted ? (
                                <form ref={form} onSubmit={sendEmail}>

                                    <div className="contact-field">
                                        <label>Full Name *</label>
                                        <input type="text" name="user_name" placeholder="Full name" required />
                                    </div>

                                    <div className="contact-field">
                                        <label>Email Address *</label>
                                        <input type="email" name="user_email" placeholder="you@email.com" required />
                                    </div>

                                    <div className="contact-field">
                                        <label>Phone Number *</label>
                                        <input type="tel" name="user_phone" placeholder="+91 00000 00000" required />
                                    </div>

                                    <div className="contact-field">
                                        <label>Request Type *</label>
                                        <select name="request_type" required>
                                            <option value="">Select Request Type</option>
                                            <option value="Feedback">Feedback</option>
                                            <option value="Complaint">Complaint</option>
                                        </select>
                                    </div>

                                    <div className="contact-field">
                                        <label>Message *</label>
                                        <textarea name="message" placeholder="Your message..." rows="4" required></textarea>
                                    </div>

                                    <button type="submit" className="contact-submit-btn" disabled={loading}>
                                        {loading ? "Sending..." : "Submit"}
                                    </button>

                                </form>
                            ) : (
                                <div className="contact-success">
                                    <h3>Message Sent Successfully!</h3>
                                    <p>Thank you! Your request has been submitted. We'll get back to you soon.</p>
                                </div>
                            )}

                        </div>

                        {/* RIGHT PANEL - IMAGE */}
                        <div className="contact-form-right">
                            <img
                                src={ContactImg}
                                alt="Bank support"
                                className="contact-right-img"
                            />
                            <div className="contact-right-overlay">
                                <h3>Sahyadri Bank Support</h3>
                                <p>Our team is always here to assist you.</p>
                            </div>
                        </div>

                    </div>
                </div>

                {/* RIGHT SIDE - CONTACT INFO */}
                <div className="contact-info">

                    <div className="contact-info-card">
                        <div className="info-icon">📍</div>
                        <h3>Head Office Address</h3>
                        <p>
                            The Sahyadri Sahakari Bank Ltd., Mumbai<br />
                            446, JSS Road, Chira Bazaar,<br />
                            Mumbai – 400002, INDIA
                        </p>
                    </div>

                    <div className="contact-info-card">
                        <div className="info-icon">📞</div>
                        <h3>Phone</h3>
                        <p>22017477 / 22016770</p>
                    </div>

                    <div className="contact-info-card">
                        <div className="info-icon">📧</div>
                        <h3>Email</h3>
                        <p>customersupport@thesahyadribank.com</p>
                    </div>

                    <div className="contact-info-card">
                        <div className="info-icon">🕒</div>
                        <h3>Working Hours</h3>
                        <p>
                            Monday – Saturady: 10:30 AM – 5:00 PM<br />
                            Saturday: 2nd and 4th Closed<br />
                            Sunday: Closed
                        </p>
                    </div>

                </div>

            </section>

        </main>
    );
};

export default Contact;